// extracted by mini-css-extract-plugin
export default {"container":"car_3OVfm","title":"car_tit_1wo6g","sponsor":"car_spo_14lgk","sponsorImage":"car_spo_3oMS2"};